// extracted by mini-css-extract-plugin
export default {"form":"WorkingHours_form__Zq0zL","row":"WorkingHours_row__OZzoI","left":"WorkingHours_left__Dq6i3"};